var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"mm",style:({ height: _vm.height + 'px'}),attrs:{"id":"mymap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }